import { render } from "./SkipMFA.vue?vue&type=template&id=23f372fd"
import script from "./SkipMFA.vue?vue&type=script&lang=js"
export * from "./SkipMFA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__